// Filtros de colección: abre y cierra el panel y filtra sin recargar. Cada cambio pide otra vez
// el listado y esta sección con la Section Rendering API y sustituye lo que cambia.

if (!customElements.get('cdc-filtros')) {
  customElements.define(
    'cdc-filtros',
    class extends HTMLElement {
      connectedCallback() {
        this.seccion = this.dataset.seccion;
        this.panel = this.querySelector('.cdc-filtros__panel');
        if (!this.panel) return;

        // El panel va al body para que ningún contenedor con transform o filtros le rompa el position: fixed
        document.querySelectorAll(`#${this.panel.id}`).forEach((panel) => panel !== this.panel && panel.remove());
        document.body.appendChild(this.panel);
        this.formulario = this.panel.querySelector('.cdc-filtros__cuerpo');

        const alPulsar = this.alPulsar.bind(this);
        this.addEventListener('click', alPulsar);
        this.panel.addEventListener('click', alPulsar);
        this.panel.addEventListener('change', this.alCambiar.bind(this));
        this.panel.addEventListener('input', this.alEscribir.bind(this));
        this.panel.addEventListener('keydown', this.alTeclear.bind(this));
        this.formulario.addEventListener('submit', (event) => {
          event.preventDefault();
          this.aplicar();
        });

        // Al volver atrás o adelante, la página se pinta tal cual con los filtros de esa URL
        window.addEventListener('popstate', () => window.location.reload());
      }

      disconnectedCallback() {
        this.panel?.remove();
      }

      alPulsar(event) {
        if (event.target.closest('.cdc-filtros__abrir')) {
          this.abrir();
          return;
        }

        if (event.target.closest('[data-cerrar]')) {
          this.cerrar();
          return;
        }

        const enlace = event.target.closest('a[data-cdc-url]');
        if (enlace) {
          event.preventDefault();
          this.cargar(enlace.href);
        }
      }

      alCambiar(event) {
        // El buscador de playa va a su propio formulario y no filtra
        if (event.target.form !== this.formulario) return;
        clearTimeout(this.esperaPrecio);
        this.aplicar();
      }

      alEscribir(event) {
        if (event.target.form !== this.formulario || event.target.type !== 'number') return;
        clearTimeout(this.esperaPrecio);
        this.esperaPrecio = setTimeout(() => this.aplicar(), 700);
      }

      alTeclear(event) {
        if (event.key === 'Escape') {
          this.cerrar();
          return;
        }

        if (event.key !== 'Tab') return;

        // El foco no sale del panel mientras está abierto
        const enfocables = [
          ...this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary'),
        ].filter((elemento) => elemento.getClientRects().length > 0);
        const primero = enfocables[0];
        const ultimo = enfocables[enfocables.length - 1];

        if (event.shiftKey && document.activeElement === primero) {
          event.preventDefault();
          ultimo.focus();
        } else if (!event.shiftKey && document.activeElement === ultimo) {
          event.preventDefault();
          primero.focus();
        }
      }

      abrir() {
        this.panel.classList.remove('cdc-filtros--cerrando');
        this.panel.hidden = false;
        document.body.classList.add('overflow-hidden');
        this.panel.querySelector('.cdc-filtros__cerrar').focus();
      }

      cerrar() {
        if (this.panel.hidden || this.panel.classList.contains('cdc-filtros--cerrando')) return;

        const terminar = () => {
          this.panel.hidden = true;
          this.panel.classList.remove('cdc-filtros--cerrando');
          document.body.classList.remove('overflow-hidden');
          this.querySelector('.cdc-filtros__abrir')?.focus();
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          terminar();
          return;
        }

        this.panel.classList.add('cdc-filtros--cerrando');
        this.panel.querySelector('.cdc-filtros__caja').addEventListener('animationend', terminar, { once: true });
      }

      aplicar() {
        const parametros = new URLSearchParams();
        for (const [clave, valor] of new FormData(this.formulario)) {
          if (String(valor).trim() !== '') parametros.append(clave, valor);
        }
        const consulta = parametros.toString();
        this.cargar(consulta ? `${window.location.pathname}?${consulta}` : window.location.pathname);
      }

      async cargar(url) {
        const listado = document.getElementById('ProductGridContainer');
        const idListado = document.getElementById('product-grid')?.dataset.id;
        if (!listado || !idListado) {
          window.location.href = url;
          return;
        }

        this.peticion?.abort();
        this.peticion = new AbortController();
        listado.querySelector('.collection')?.classList.add('loading');
        this.panel.classList.add('cdc-filtros--cargando');

        try {
          const separador = url.includes('?') ? '&' : '?';
          const respuesta = await fetch(`${url}${separador}sections=${idListado},${this.seccion}`, {
            signal: this.peticion.signal,
          });
          if (!respuesta.ok) throw new Error(respuesta.status);

          const secciones = await respuesta.json();
          const lector = new DOMParser();
          const nuevoListado = lector
            .parseFromString(secciones[idListado], 'text/html')
            .getElementById('ProductGridContainer');
          const nuevosFiltros = lector.parseFromString(secciones[this.seccion], 'text/html');

          if (nuevoListado) {
            listado.innerHTML = nuevoListado.innerHTML;
            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(listado);
          }
          this.actualizar(nuevosFiltros);
          window.history.pushState({ cdcFiltros: true }, '', url);
        } catch (error) {
          if (error.name !== 'AbortError') window.location.href = url;
        } finally {
          listado.querySelector('.collection')?.classList.remove('loading');
          this.panel.classList.remove('cdc-filtros--cargando');
        }
      }

      actualizar(documento) {
        const barra = documento.querySelector('.cdc-filtros__barra');
        if (barra) this.querySelector('.cdc-filtros__barra').replaceWith(barra);

        // Del panel solo cambia lo que depende de los resultados, para no perder el foco ni el scroll
        documento.querySelectorAll('.cdc-filtros__panel input[id]').forEach((nueva) => {
          const actual = document.getElementById(nueva.id);
          if (!actual || actual.type === 'search') return;
          if (actual.type === 'number') {
            // El precio se respeta mientras se escribe; si se quita desde su etiqueta, se vacía
            if (document.activeElement !== actual) actual.value = nueva.value;
            return;
          }
          actual.disabled = nueva.disabled;
          actual.checked = nueva.checked;
        });

        documento.querySelectorAll('.cdc-filtros__panel details.cdc-filtros__grupo > summary').forEach((nuevo, indice) => {
          const actual = this.panel.querySelectorAll('details.cdc-filtros__grupo > summary')[indice];
          if (actual) actual.innerHTML = nuevo.innerHTML;
        });

        ['.cdc-filtros__ver', '.cdc-filtros__limpiar'].forEach((selector) => {
          const nuevo = documento.querySelector(selector);
          const actual = this.panel.querySelector(selector);
          if (nuevo && actual) actual.replaceWith(nuevo);
        });
      }
    }
  );
}
